//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockTransferLog', {
//        templateUrl: 'views/components/views/stockTransferLog/stockTransferLog.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stockTransferLogService', 'ttGridFactory', function ($stateParams, utilityService, stockTransferLogService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockTransferKeyno = $stateParams.stocktransfer_keyno;

//            vm.model = {
//                gridReady: false,
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_stocktransferlog_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadSetting() {
//                vm.model.setting = (await stockTransferLogService.getStockTransferLog({ stocktransfer_keyno: stockTransferKeyno }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.stocktransfer_keyno) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 2318,
//                    parameters: { stocktransfer_keyno: vm.model.setting.stocktransfer_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
